import { INote } from "src/shared/models/TakeNotesModel";
import { IReduxOperations } from "src/store";

export enum ClearTypes {
  FETCH = "FETCH",
  UPDATE = "UPDATE",
  ADD = "ADD",
}

export interface INotesRootState {
  fetchedNotes: IReduxOperations;
  addedNotes: IReduxOperations;
  updatedNotes: IReduxOperations;
}

export type FetchNotesPayload = {
  userDetails: {
    pinId: string;
  };
  selectedTabValue: null | string;
};

export type AddNotesPayload = {
  data: {
    text: string;
    snapshotDetail: string | undefined;
  };
  userDetails: {
    pinId: number;
  };
};

export type UpdateNotesPayload = {
  data: INote;
  userDetails: {
    pinId: number;
  };
  navigateOnSuccessfullUpdate: () => void;
};
